import {createReducer} from '@reduxjs/toolkit';
import {
    clearChangeRequestsFilters,
    setAllChangeRequestsFilters,
    setChangeRequestsFilter,
} from 'src/modules/change-requests/services/filters/actions';
import {Filters} from 'src/modules/change-requests/typedefs';

type State = {
    data: Filters,
};

export const defaultState: State = {
    data: {
        type: [],
        source: [],
        code: [],
        description: [],
        authorEmail: [],
        status: [],
        updateDate: {from: '', to: ''},
        dueDate: {from: '', to: ''},
    },
};

export const changeRequestsFilters = createReducer<State>(defaultState, builder => builder
    .addCase(setChangeRequestsFilter, (state, action) => {
        state.data = {
            ...state.data,
            [action.payload.filterType]: action.payload.filterValue,
        };
    })
    .addCase(clearChangeRequestsFilters, state => {
        state.data = defaultState.data;
    })
    .addCase(setAllChangeRequestsFilters, (state, action) => {
        state.data = action.payload;
    }),
);
